import { EventRegistryCategory } from '../../EventRegistryCategory';
import { EventRegistryItem } from '../../EventRegistryItem';
export class EventRegistryReactClipboard extends EventRegistryCategory {
    label = 'Clipboard Events';
    constructor(parent) {
        super(parent);
        super.init();
    }
    copy = () => new EventRegistryItem({ handlerName: 'onCopy' });
    cut = () => new EventRegistryItem({ handlerName: 'onCut' });
    paste = () => new EventRegistryItem({ handlerName: 'onPaste' });
}
